import * as React from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

const SvgDeleteIcon = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path
      clipRule="evenodd"
      d="M6.73 8.386H5V6.63h3.462V4.877c0-.484.387-.877.865-.877h5.192c.478 0 .866.393.866.877v1.754h3.461v1.755h-1.73v8.771c0 .969-.776 1.754-1.731 1.754H8.462c-.956 0-1.731-.785-1.731-1.754zm1.732 0v7.894c0 .484.387.877.865.877h5.192a.87.87 0 0 0 .866-.877V8.386zm1.73-1.755h3.462v-.877h-3.462z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  )
export default SvgDeleteIcon
